import { render, staticRenderFns } from "./Canny.vue?vue&type=template&id=2ac67389&scoped=true&"
import script from "./Canny.vue?vue&type=script&lang=js&"
export * from "./Canny.vue?vue&type=script&lang=js&"
import style0 from "./Canny.vue?vue&type=style&index=0&id=2ac67389&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac67389",
  null
  
)

export default component.exports